import { z } from 'zod';

export const datetimeSchema = z
  .string()
  .datetime()
  .or(z.date())
  .transform((val) => (typeof val === 'string' ? val : String(val)));

export const dateSchema = z
  .string()
  .date()
  .or(z.date())
  .transform((val) => (typeof val === 'string' ? val : val.toISOString().slice(0, 10)));

export const apiErrorResponseSchema = z.object({
  status: z.number(),
  title: z.string(),
  detail: z.string(),
  type: z.string(),
});

export type ApiErrorResponse = z.infer<typeof apiErrorResponseSchema>;

export const HexColorSchema = z.string().regex(/^#[A-F0-9]{6}$/i);

export const LocalDateTimeStringSchema = z.string().refine(
  (str) =>
    z
      .string()
      .datetime()
      // Accept 2021-08-31T00 2021-08-31T00:00 2021-08-31T00:00:00
      .safeParse(`${str.padEnd(19, ':00')}Z`).success,
  { message: 'Invalid date time' },
);

export const DateStringSchema = z
  .string()
  .regex(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/, { message: 'Invalid date' });

export const TimeStringSchema = z.string().regex(/^([0-1]\d|2[0-3])(?::([0-5]\d)){1,2}$/, { message: 'Invalid time' });

export const EmailStringSchema = z
  .string()
  .regex(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  );

export const BooleanStringSchema = z.enum(['true', 'false']);
